module.exports = __webpack_public_path__ + "img/logo_8V.64a6a886.png";